import { s as sagas, i as initialState, r as reducer, a as actions } from '../saga-afaced62.js';
export { a as vendorActions, i as vendorInitialState, r as vendorReducers, s as vendorSagas } from '../saga-afaced62.js';
import { v as vendorStoreName } from '../constants-f7891ee3.js';
export { v as vendorStoreName } from '../constants-f7891ee3.js';
import 'redux-saga/effects';
import '@frontegg/rest-api';
import '@reduxjs/toolkit';

// export store
var vendorStore = {
    sagas,
    storeName: vendorStoreName,
    initialState,
    reducer,
    actions,
};

export { vendorStore as default };
